import { FC } from 'react';
import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { useIsDesktop, useDictionary } from 'Hooks';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { GrayTrash, PurpleArrowIcon } from 'Images';

interface IDocumentTypeCollapseHeader {
  subjectName: string;
  isOpen: boolean;
  fileCount: number;
  onDelete: () => void;
  toggleIsOpen: () => void;
  showDeleteButton: boolean;
}

export const DocumentTypeCollapseHeader: FC<IDocumentTypeCollapseHeader> = ({
  subjectName,
  isOpen,
  fileCount,
  onDelete,
  toggleIsOpen,
  showDeleteButton,
}) => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.UniversalRequest);

  return (
    <Box
      sx={{
        padding: isDesktop ? '16px 24px' : '12px 16px',
        backgroundColor: '#FFFFFF',
        transition: 'background-color 0.3s ease-in-out',
        cursor: 'pointer',
      }}
      onClick={toggleIsOpen}
    >
      <Stack direction='row' alignItems='center' justifyContent='space-between'>
        <Stack
          direction='row'
          alignItems='center'
          gap='8px'
          width='fit-content'
        >
          <Stack
            flexDirection={isDesktop ? 'row' : 'column'}
            gap={isDesktop ? '8px' : '0px'}
            alignItems={isDesktop ? 'baseline' : 'flex-start'}
          >
            <Typography variant='body1'>{subjectName}</Typography>
            {fileCount === 0 && (
              <Typography variant='body6'>
                {dictionary.uploadFile.didNotAddFile}
              </Typography>
            )}
          </Stack>
          {fileCount > 0 && (
            <Stack
              sx={{
                backgroundColor: '#F4E4FF',
                borderRadius: '10px',
                height: '20px',
                width: '20px',
                minWidth: '20px',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <Typography
                sx={{
                  fontSize: '12px !important',
                  fontWeight: '700 !important',
                  color: '#A020FF',
                }}
              >
                {fileCount}
              </Typography>
            </Stack>
          )}
        </Stack>
        <Stack
          direction='row'
          alignItems='center'
          gap='24px'
          width='fit-content'
        >
          {showDeleteButton && (
            <Button
              onClick={onDelete}
              sx={{
                gap: '2px',
                bgcolor: '#F6F8FE',
                p: '5px 8px 5px 12px',
                borderRadius: '6px',
                border: '1px solid transparent',
                '&:hover': {
                  bgcolor: '#F6F8FE',
                  borderColor: '#343D66',
                },
              }}
            >
              <Avatar
                src={GrayTrash}
                sx={{
                  width: '20px',
                  height: '20px',
                }}
                alt=''
              />
              <Typography color='#656F8B' variant='body5'>
                {dictionary.uploadFile.delete}
              </Typography>
            </Button>
          )}
          <Avatar
            src={PurpleArrowIcon}
            sx={{
              width: '20px',
              height: '20px',
              transition: 'transform 0.3s ease-in-out',
              transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            alt=''
          />
        </Stack>
      </Stack>
    </Box>
  );
};
